<template>
  <div class="country-icon">
    <span class="fi" :class="[`fi-${iso2.toLowerCase()}`]"></span>
  </div>
</template>

<script setup lang="ts">
import 'flag-icons/css/flag-icons.min.css'

defineProps<{
  iso2: string
}>()
</script>

<style scoped lang="scss">
.country-icon {
  border-radius: 2px;
  overflow: hidden;

  .fi {
    display: block;
    width: 24px;
    height: 16px;
  }
}
</style>
